import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input-frame" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.textInner) = $event))
    }, null, 512), [
      [_vModelText, _ctx.textInner]
    ]),
    _createElementVNode("div", {
      class: "clear-button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickClear && _ctx.onClickClear(...args)))
    }, [...(_cache[2] || (_cache[2] = [
      _createElementVNode("div", { class: "x-icon" }, null, -1)
    ]))])
  ]))
}